module.exports = __webpack_public_path__ + "img/9791187206613.3ed5c5ba.jpg";